module.exports = __webpack_public_path__ + "img/img_series_116.66287244.png";